
import { FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Control } from "react-hook-form";
import { PURCHASING_TYPES } from "@/constants/buyerFormOptions";

interface PurchasingTypesFieldProps {
  control: Control<any>;
  selectedPurchasingTypes: string[];
  onPurchasingTypeToggle: (type: string, checked: boolean) => void;
  isEditing: boolean;
}

const PurchasingTypesField = ({
  control,
  selectedPurchasingTypes,
  onPurchasingTypeToggle,
  isEditing
}: PurchasingTypesFieldProps) => {
  return (
    <FormField
      control={control}
      name="purchasingType"
      render={() => (
        <FormItem>
          <FormLabel>Purchasing Types</FormLabel>
          <div className={`grid grid-cols-2 md:grid-cols-3 gap-2 p-4 rounded border ${!isEditing ? 'bg-muted border-muted' : 'bg-background border-border'}`}>
            {PURCHASING_TYPES.map((type) => (
              <div key={type} className="flex items-center space-x-2">
                <Checkbox
                  id={type}
                  checked={selectedPurchasingTypes.includes(type)}
                  onCheckedChange={(checked) => onPurchasingTypeToggle(type, checked as boolean)}
                  disabled={!isEditing}
                />
                <Label 
                  htmlFor={type} 
                  className={`text-sm cursor-pointer ${!isEditing ? 'text-muted-foreground' : ''}`}
                >
                  {type}
                </Label>
              </div>
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PurchasingTypesField;
